// external imports
import React from 'react'
import Helmet from 'react-helmet'
import { FlexRow, FlexColumn } from 'quark-web'
// local imports
import { Header, LocationBilling, LocationResearch, LocationDistributors } from '~/components'
import Form from './Form'
import styles from './styles'

const Contact = () => (
    <>
        <Helmet title="Contact" />
        <Header style={{ marginBottom: 40 }}>contact</Header>
        <FlexRow grow={1}>
            <FlexColumn style={{ width: 410, marginRight: 50 }}>
                <LocationBilling />
                <LocationResearch />
                <LocationDistributors />
            </FlexColumn>
            <Form style={{ width: 520 }} />
        </FlexRow>
    </>
)

const SimpleContact = () => (
    <>
        <Helmet title="Contact" />
        <Header style={styles.header}>contact</Header>
        <Form style={styles} />
    </>
)

export default SimpleContact



// WEBPACK FOOTER //
// ./src/views/Contact/index.js